import {
  LoyaltyActivateTransactionItemFragment,
  LoyaltyPointChangeItemFragment,
  TransactionHistoryItemFragment,
} from '@ocx/graphql';

export type SanitizedActivateTransactionEdge = {
  cursor: string;
  node: LoyaltyActivateTransactionItemFragment;
};

export type SanitizedPointChangeEdge = {
  cursor: string;
  node: LoyaltyPointChangeItemFragment;
};

export type SanitizedTransactionHistoryEdge = {
  cursor: string;
  node: TransactionHistoryItemFragment;
};

export enum TransactionHistoryItemType {
  PointsChange = 'PointsChange',
  LoyaltyEvent = 'LoyaltyEvent',
  Transaction = 'Transaction',
  OrderAhead = 'OrderAhead',
  Cancelled = 'Cancelled',
}

export type TransactionHistoryItem = {
  id: string;
  title: string;
  points: number | null;
  type: TransactionHistoryItemType;
  date: string;
  dateTitle: string;
  groupedDate: string;
  totalAmount: number | null;
  totalAmountWithoutDiscounts: number | null;
};

export type TransactionHistorySegment = [string, TransactionHistoryItem[]];
